var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonNotificationDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 6.06185C13.3327 7.9028 11.8403 9.39518 9.99935 9.39518C8.1584 9.39518 6.66602 7.9028 6.66602 6.06185C6.66602 4.2209 8.1584 2.72852 9.99935 2.72852C11.8403 2.72852 13.3327 4.2209 13.3327 6.06185Z",
    stroke: "#27532D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 11.8952C6.77769 11.8952 4.16602 14.5069 4.16602 17.7285H15.8327C15.8327 14.5069 13.221 11.8952 9.99935 11.8952Z",
    stroke: "#27532D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonNotificationDashboard);
export default __webpack_public_path__ + "static/media/person-notification-dashboard.4fdaa95a6731debfbe235e39cb7f5503.svg";
export { ForwardRef as ReactComponent };